module.exports = __webpack_public_path__ + "static/media/BoxPlotQ5_2.f3188d74.svg";